export default "__VITE_ASSET__jWSkTbQX__"